import React from 'react';

const AdminModal = ({ children, handleClose, isOpen, title }) => {
  if (!isOpen) return null;
  return (
    <div className='fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 '>
      <div className='relative w-[min(92vw,720px)] max-h-[85vh] overflow-y-auto bg-white p-6 rounded shadow-lg'>
        <button
          type='button'
          aria-label='Close'
          onClick={handleClose}
          className='absolute right-3 top-3 inline-flex h-8 w-8 items-center justify-center rounded border border-gray-200 bg-white text-lg font-bold leading-none text-gray-700 transition-colors duration-200 hover:border-red-300 hover:text-red-600'
        >
          x
        </button>
        <h2 className='text-xl font-bold mb-4'>{title}</h2>
        <div>{children}</div>
      </div>
    </div>
  );
};

export default AdminModal;
